import React from "react";

const RightComponentCard = () => {
  return (
    <>
      <div
        style={{
          background: "#eeeeee",
          width: "308px",
          // height: "595px",
          borderRadius: "4px",
        }}
        className=""
      >
        <div style={{ background: "#eeeeee", width: "308px" }} className="flex items-center">
          <div
            style={{
              background: "#bbbbbb",
              width: "304px",
              borderRadius: "4px",
            }}
            className=" p-px ml-2px mt-3px mb-2px mr-2px"
          >
            <div
              style={{
                background: "linear-gradient(to right, #9d3bbb, #5423a0)",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                width: "302px",
              }}
              className="flex items-center justify-between h-40px"
            >
              <div className="flex items-center ml-6px">
                <p className="text-white text-12px font-bold tracking-tight">ID :</p>
                <p style={{ color: "#f2ea37" }} className="ml-4px text-12px font-bold tracking-tight">
                  4004791
                </p>
                <div
                  style={{
                    background: "#6b2539",
                    width: "44px",
                    height: "21px",
                    borderRadius: "4px",
                  }}
                  className="p-px ml-5px mt-11px mb-10px"
                >
                  <div
                    style={{
                      background: "#d60447",
                      borderRadius: "4px",
                      height: "19px",
                    }}
                    className="flex items-center"
                  >
                    <p className="ml-4px text-11px text-white font-bold tracking-tight pt-px">대기중</p>
                  </div>
                </div>
              </div>
              <div>
                <p className="mr-7px text-12px text-white font-bold tracking-tight">2021-06-29 16:00:30</p>
              </div>
            </div>

            <div
              style={{
                background: "linear-gradient(to right, #ffeaf5, #d4e8ff)",
                borderColor: "#bbbbbb",
                minHeight: "78px",
              }}
              className="items-center border-b"
            >
              <p style={{ color: "#222" }} className="ml-6px pt-8px text-12px font-semibold tracking-tight">
                아스널 VS 리버풀
              </p>
              <p style={{ color: "#444444" }} className="ml-6px mt-3px  text-12px font-malgun tracking-tight">
                승무패[정규시간]
              </p>
              <div className="flex items-center justify-between mb-9px mt-2px">
                <p
                  style={{ color: "#5e399a", marginTop: "1px", maxWidth: "240px" }}
                  className="ml-6px text-12px font-bold tracking-tight"
                >
                  리버풀
                </p>
                <p
                  style={{ color: "#0072bc", marginTop: "1px" }}
                  className="mr-7px -mb-px text-12px font-bold tracking-tight"
                >
                  3.47
                </p>
              </div>
            </div>

            <div
              style={{
                background: "linear-gradient(to right, #ffeaf5, #d4e8ff)",
                borderColor: "#bbbbbb",
                minHeight: "78px",
              }}
              className="items-center border-b"
            >
              <p style={{ color: "#222" }} className="ml-6px pt-8px text-12px font-semibold tracking-tight">
                FC바르셀로나 VS 아틀레티코
              </p>
              <p style={{ color: "#444444" }} className="ml-6px mt-3px -mb-2px text-12px font-malgun tracking-tight">
                승무패[정규시간]
              </p>
              <div className="flex items-center justify-between mb-9px mt-2px">
                <p
                  style={{ color: "#5e399a", maxWidth: "240px" }}
                  className="ml-6px mt-3px text-12px font-bold tracking-tight"
                >
                  FC바르셀로나
                </p>
                <p style={{ color: "#f04281" }} className="mr-7px -mb-4px text-12px font-bold tracking-tight">
                  2.26
                </p>
              </div>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "34px",
              }}
              className="flex items-center justify-between border-b"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-13px mb-14px text-12px font-bold tracking-tight">
                총 배당
              </p>
              <p style={{ color: "#e9441d" }} className="mr-7px mt-12px mb-13px text-12px font-bold tracking-tight">
                10.00
              </p>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "34px",
              }}
              className="flex items-center justify-between border-b"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-12px mb-13px text-12px font-bold tracking-tight">
                총 베팅금액
              </p>
              <p style={{ color: "#333" }} className="mr-7px mt-9px mb-11px text-12px font-bold tracking-tight">
                5,000
              </p>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "34px",
              }}
              className="flex items-center justify-between border-b"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-11px mb-12px text-12px font-bold tracking-tight">
                당첨 예상금액
              </p>
              <p style={{ color: "#333" }} className="mr-7px mt-10px mb-11px text-12px font-bold tracking-tight">
                50,000
              </p>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "33px",
                borderBottomLeftRadius: "4px",
                borderBottomRightRadius: "4px",
              }}
              className="flex items-center justify-between"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-11px mb-14px text-12px font-bold tracking-tight">
                티켓번호
              </p>
              <p style={{ color: "#0072bc" }} className="mr-7px mt-11px mb-14px text-12px font-bold tracking-tight">
                4004791
              </p>
            </div>
          </div>
        </div>

        <div style={{ background: "#eeeeee", width: "308px", borderRadius: "4px" }} className="flex items-center">
          <div
            style={{
              background: "#bbbbbb",
              width: "304px",
              borderRadius: "4px",
            }}
            className="p-px ml-2px mb-2px mr-2px"
          >
            <div
              style={{
                background: "linear-gradient(to right, #9d3bbb, #5423a0)",
                width: "302px",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
              }}
              className="flex items-center justify-between h-40px"
            >
              <div className="flex items-center ml-6px">
                <p className="text-white text-12px font-bold tracking-tight">ID :</p>
                <p style={{ color: "#f2ea37" }} className="ml-4px text-12px font-bold tracking-tight">
                  4004998
                </p>
                <div
                  style={{
                    background: "#2b1160",
                    width: "44px",
                    height: "21px",
                    borderRadius: "4px",
                  }}
                  className="p-px ml-5px mt-11px mb-10px"
                >
                  <div
                    style={{
                      background: "#461e96",
                      borderRadius: "4px",
                      height: "19px",
                    }}
                    className="flex items-center"
                  >
                    <p className="ml-9px text-11px text-white font-bold tracking-tight pt-px">수락</p>
                  </div>
                </div>
              </div>
              <div>
                <p className="mr-7px text-12px text-white font-bold tracking-tight">2021-06-29 16:00:20</p>
              </div>
            </div>

            <div
              style={{
                background: "linear-gradient(to right, #ffeaf5, #d4e8ff)",
                borderColor: "#bbbbbb",
                minHeight: "78px",
              }}
              className="items-center border-b"
            >
              <p style={{ color: "#222" }} className="ml-6px pt-8px text-12px font-semibold tracking-tight">
                FC바르셀로나 VS 아틀레티코
              </p>
              <p style={{ color: "#444444" }} className="ml-6px mt-3px -mb-2px text-12px font-malgun tracking-tight ">
                승무패[정규시간]
              </p>
              <div className="flex items-center justify-between mb-9px mt-2px">
                <p
                  style={{ color: "#5e399a", maxWidth: "240px" }}
                  className="ml-6px mt-3px text-12px font-bold tracking-tight"
                >
                  FC바르셀로나
                </p>
                <p style={{ color: "#f04281" }} className="mr-7px -mb-4px text-12px font-bold tracking-tight">
                  2.26
                </p>
              </div>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "34px",
              }}
              className="flex items-center justify-between border-b"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-13px mb-14px text-12px font-bold tracking-tight">
                총 배당
              </p>
              <p style={{ color: "#e9441d" }} className="mr-7px mt-12px mb-13px text-12px font-bold tracking-tight">
                2.26
              </p>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "34px",
              }}
              className="flex items-center justify-between border-b"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-12px mb-13px text-12px font-bold tracking-tight">
                총 베팅금액
              </p>
              <p style={{ color: "#333" }} className="mr-7px mt-9px mb-11px text-12px font-bold tracking-tight ">
                5,000
              </p>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "34px",
              }}
              className="flex items-center justify-between border-b"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-12px mb-13px text-12px font-bold tracking-tight">
                당첨 예상금액
              </p>
              <p style={{ color: "#333" }} className="mr-7px mt-10px mb-11px text-12px font-bold tracking-tight">
                11,300
              </p>
            </div>

            <div
              style={{
                background: "#ffffff",
                borderColor: "#eeeeee",
                height: "33px",
                borderBottomLeftRadius: "4px",
                borderBottomRightRadius: "4px",
              }}
              className="flex items-center justify-between"
            >
              <p style={{ color: "#333" }} className="ml-6px mt-11px mb-14px text-12px font-bold tracking-tight">
                티켓번호
              </p>
              <p style={{ color: "#0072bc" }} className="mr-7px mt-11px mb-14px text-12px font-bold tracking-tight">
                4004791
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RightComponentCard;
